import { Routes, Route, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthProvider'
import { ProtectedRoute } from './components/ProtectedRoute'
import ErrorBoundary from './components/ErrorBoundary'
import LoginPage from './pages/LoginPage/LoginPage'
import RegisterPage from './pages/RegisterPage/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage'
import LearnWordsPage from './pages/LearnWordsPage/LearnWordsPage'
import DashboardPage from './pages/DashboardPage/DashboardPage'
import PlaygroundPage from './pages/PlaygroundPage/PlaygroundPage'
import FillInTheBlankPage from './pages/FillInTheBlankPage/FillInTheBlankPage'
import FillInTheBlankSelectPage from './pages/FillInTheBlankSelectPage'
import ExamplesPage from './pages/ExamplesPage/ExamplesPage'
import LandingPage from './pages/LandingPage/LandingPage'
import Header from './components/Header/Header'
import Footer from './components/Footer'
import { useAuth } from './hooks/useAuth'

function RootRedirect() {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }
  
  if (user) {
    return (
      <>
        <Header />
        <div className="flex-1">
          <DashboardPage />
        </div>
      </>
    )
  }
  
  return <LandingPage />
}

function App() {
  const location = useLocation();
  const isLandingPage = location.pathname === '/' || location.pathname === '/landing';

  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="min-h-screen flex flex-col">
          <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/collection" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <LearnWordsPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <DashboardPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="/practice" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <PlaygroundPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="/practice/fill-in-the-blank/:id" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <FillInTheBlankPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="/practice/fill-in-the-blank-select" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <FillInTheBlankSelectPage />
              </div>
            </ProtectedRoute>
          } />
          <Route path="/examples" element={
            <ProtectedRoute>
              <Header />
              <div className="flex-1">
                <ExamplesPage />
              </div>
            </ProtectedRoute>
          } />
          </Routes>
          <Footer variant={isLandingPage ? 'landing' : 'dashboard'} />
        </div>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
